import { StallSaleSaveSync } from '@/domain/economy/stallSaleSaveSync';
import { refreshSaveFromServer } from './economyActions';
import { useGameStore } from '@/ui/store/gameStore';

const syncByUser = new Map<string, StallSaleSaveSync>();

function saleSync(userId: string): StallSaleSaveSync {
  let sync = syncByUser.get(userId);
  if (!sync) {
    sync = new StallSaleSaveSync(async () => {
      if (useGameStore.getState().currentUser?.id === userId) await refreshSaveFromServer();
    });
    syncByUser.set(userId, sync);
  }
  return sync;
}

export function invalidateStallSaleSave(userId: string): void { saleSync(userId).invalidate(); }
export function syncStallSaleSave(userId: string): Promise<void> { return saleSync(userId).flush(); }
